import React from "react";
import football1 from "../../assets/images/rules/football-1.png";
import football2 from "../../assets/images/rules/football-2.png";

function TrafficHomeOne({ className }) {
  return (
    <section className={`appie-service-area pt-140 pb-180 ${className || ""}`}>
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="appie-traffic-title" style={{ paddingRight: 0 }}>
              <h3 className="title ">Football Rules and Regulations</h3>
              <div>
                <ol>
                  <li>
                    a. Common rules
                    <ul>
                      <li>• 3 Points per win</li>
                      <li>• 1 Point each for a tied match</li>
                    </ul>
                  </li>
                  <li>
                    b. Ranking shall be done on the basis of points and if the
                    points are equal following things will be considered in the
                    same sequence –
                    <ul>
                      <li>• Goal Difference</li>
                      <li>• No of goals scored</li>
                      <li>• No of goals conceded</li>
                      <li>• Penalty Shootout</li>
                    </ul>
                  </li>
                  <li>
                    <ul>
                      <li>
                        <ul>
                          <h3> Playing Conditions</h3>
                          <li>
                            • 8 persons playing per side except for the
                            substitutes
                          </li>
                          <li>
                            • Rolling Substitution only after taping in at the
                            half line)
                          </li>
                          <li>
                            • Each half will be of 15 Minutes with 5 Minutes
                            break in between.
                          </li>
                          <li>
                            • No Extra Time & Penalty Shoot out in League
                            Matches
                          </li>
                          <li>
                            • In Knockout matches, extra time would be 10
                            Minutes (5 Minutes half with 2 minutes break)
                          </li>
                          <li>
                            • Penalty Shoot out in case of a tie in Knockout
                            Matches
                          </li>
                          <li>
                            • Red Cards & 2 Yellow Card in the same match
                            Consequence – The player is not allowed to play in
                            that match and next match.
                          </li>
                          <li>
                            • At any given time only the Captain of the Team
                            must & has the right to speak
                          </li>
                          <li>
                            • Goal Keeper can be changed only when play is
                            paused
                          </li>
                          <li>
                            • Goalkeeper has to compulsorily wear Football Goal
                            Keeping Gloves
                          </li>
                          <li>• Only Kick in is allowed for outside</li>
                          <li>• No goals allowed directly from kick in</li>
                          <li>
                            • If the playing side of a team is less than 5 than
                            the opposition team will be declared winner
                          </li>
                          <li>• Shoes Instructions –</li>
                        </ul>
                        <img src={football1} alt="0" />
                        <br />
                        <img src={football2} alt="0" />
                      </li>
                    </ul>
                  </li>
                </ol>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default TrafficHomeOne;
